const setStartAndEndIndexes = (totalPages, scrollPages, currentPage) => {
    let startIndex, endIndex;

    const isOdd = scrollPages % 2 !== 0;
    let countRef = Math.ceil((isOdd ? scrollPages - 1 : scrollPages) / 2);

    if (isOdd) {
        ++countRef;
    }

    if (currentPage > countRef) {
        startIndex = currentPage - countRef + 1;

        if (isOdd) {
            --countRef;
        }
        endIndex = currentPage + countRef;
    } else {
        startIndex = 1;
        endIndex = scrollPages;
    }

    if (endIndex > totalPages) {
        endIndex = totalPages;
        startIndex = totalPages - scrollPages + 1;
    }

    if (startIndex <= 0) {
        startIndex = 1;
    }

    return [startIndex, endIndex];
};

export { setStartAndEndIndexes };
